import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import stateSlice from './features/state'
import categoriesSlice from './features/categories'
import productsSlice from './features/products'
import cartSlice from './features/cart'
import authSlice from './features/auth'
import orderSlice from './features/orders'

const cartPersistConfig = {
	key: 'cart',
	storage,
}

const authPersistConfig = {
	key: 'auth',
	storage
}

const orderPersistConfig = {
	key: 'order',
	storage
}

const rootReducer = combineReducers({
	state: stateSlice,
	category: categoriesSlice,
	product: productsSlice,
	cart: persistReducer(cartPersistConfig, cartSlice),
	auth: persistReducer(authPersistConfig, authSlice),
	orders: persistReducer(orderPersistConfig, orderSlice),
})

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
